module.exports = __webpack_public_path__ + "img/SealPercent.c5d01cfe.svg";